module.exports = __webpack_public_path__ + "img/logo-analytics.9d501c7c.png";